import { GetProjectResponseProject } from "src/model/api/v2/data-contracts";
import { hasPermissionForFuncInRole } from "src/utils/controllerHasPermissionsAdapter";
import { useGetVersionQuery } from "src/api/app-ApiSlice";

export function IsElectricalCabinetAvailable(
    extendedProject: GetProjectResponseProject
): boolean {
    const { data: version } = useGetVersionQuery();

    return !!(
        version?.is_pro &&
        extendedProject.paidFeature?.stromlaufplan_paid &&
        hasPermissionForFuncInRole("docu_sect.dl_electricalplan", extendedProject.userRole)
    );
}
